export default __webpack_public_path__ + "static/media/amberlogo.46b5e2d6.png";